/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useState } from "react";
import { useDispatch } from "react-redux";
import { Logger } from "cms/utils/log/logger";
import { useAuth } from "cms/auth/hooks/use-auth";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { setLayouts } from "data/store/reducers/layout";

const useLayout = function () {
    
    const dispatch = useDispatch();
    const { token } = useAuth();
    const [hasLayouts, setHasLayouts] = useState(false);
    
    const fetchLayoutData = async () => {
        if (!hasLayouts) {
            try {
                // Logger.info('Loading layout data...')
                const layouts = await SimpliCityAdminSDK.layout.find(token);
                // console.info(`%c[use-layout] Layout data loaded..`, `color: #27e7f5`)
                Logger.info("[use-layout] Layout data loaded..");
                // Logger.flush()
                dispatch(setLayouts(layouts));
                setHasLayouts(true);
            } catch (error) {
                // Logger.warn(`%c[use-layout] Failed to load layouts data: ${error.message}`, `color: #27e7f5`)
                Logger.warn(`[use-layout] Failed to load layouts data: ${error.message}`);
                Logger.error(error.message);
                // Logger.flush()
                setHasLayouts(false);
            }
        }
    };
    
    return {
        fetchLayoutData
    };
};

export { useLayout };
